import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { ApplicationService, DataService } from '../../services';
import { Router } from '@angular/router';
import {AppConfig} from '../../_config';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  isDisabled = false;
  options: FormGroup;
  oldApp= false;
  CardNumber:any;
  AppNumber:any;
  logo = '';
  banner='';
  mainPage=true;
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');
  constructor(fb: FormBuilder,private applicationService: ApplicationService,
     public route: Router, appConfig:AppConfig) {
       this.logo = appConfig.logoPath;
       this.banner = appConfig.bannerPath;
  }
  
ngOnInit(){
  DataService.set('isLanding',true);
}
 
  searchApp(){
    this.oldApp = true;
  }
  back(){
    this.oldApp =false;
  } 
 async proceed(){
    const searchRequest={};
    searchRequest['Email'] = this.CardNumber;
      searchRequest['AccountApplicationNumber'] =this.AppNumber;
      await this.applicationService.readApplication(searchRequest).toPromise().
      then(async res => {
        if(res && res.data==null && res.status && res.status.code == '404'){
          console.log(res.status.message);
          this.route.navigate(['/home']);
        }
        else if(res && res.data!=null && res.status && res.status.code=='200'){
          DataService.set('Account',res.data);
          this.route.navigate(['/home']);
        }
      }).catch(err=>
       console.log(err));
  }


}
